import { useTranslation } from 'react-i18next';
import { FormControl } from '@mui/material';
import { FieldArray } from 'redux-form';
import { requiredArray } from '../../../util/validators';
import React from 'react';
import { DynamicComponentInput, DynamicFormFieldArray, renderDynamicComponent } from './DynamicComponent';
import { FieldNames } from '../../../models/fields/names';
import { DynamicFormFieldArrayType } from '../../../models/options/enums';
import { cashInitialValue } from '../../../util/initial-values';
import { ASSET_CASH_TYPE_OPTIONS } from 'app/models/options/options';

const cashInputs: DynamicComponentInput[] = [
  {
    fieldName  : FieldNames.financialStatementFinancialInstitution,
    isOptional : false,
    label      : 'Financial Institution',
    type       : DynamicFormFieldArrayType.TEXT_INPUT,
  },
  {
    fieldName  : FieldNames.financialStatementAccountType,
    isOptional : false,
    label      : 'Account Type',
    options    : ASSET_CASH_TYPE_OPTIONS,
    type       : DynamicFormFieldArrayType.SELECT,
  },
  {
    fieldName  : FieldNames.financialStatementCurrentBalance,
    isOptional : false,
    label      : 'Current Balance',
    type       : DynamicFormFieldArrayType.CURRENCY,
  },
  {
    fieldName  : FieldNames.financialStatementJointAccount,
    isOptional : false,
    label      : 'Is this a joint account?',
    type       : DynamicFormFieldArrayType.Y_N_SWITCH_TOGGLE,
  },
];

const cashProps: DynamicFormFieldArray = {
  addButtonText : 'Account',
  initialValue  : cashInitialValue,
  inputs        : cashInputs,
};

export const CashFFAComponent = ({ ...props }) => {
  const { name, options } = props;
  const { t }    = useTranslation();

  return (
    <FormControl fullWidth>
      <FieldArray
        component = {renderDynamicComponent}
        name      = { name }
        props     = { { dynamicProps: cashProps, name, t, options } }
        validate  = {[
          requiredArray([]),
        ]}
      />
    </FormControl>
  );
};
